// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.flowLegend_J0vA1 {
	position : absolute;
	right : 8px;
	bottom : 8px;
	display : flex;
	flex-direction: column;
	gap : 8px;
	z-index: 100;
}

.blueprint_eSzYM {
	/* background-color: #cdffb2; */
  /* border: 1px solid #6eaa49; */
	background-color: #E4E2F7;
  border: 1px solid #261ACB;
	border-radius : 0;
	color: black;
	font-size: 12px;
	padding: 4px;
	text-align: left;
}

.oneToOneFlowLink_dFxLn {
	background-color: #FFF2CC;
	color: black;
	border: 1px solid #FFD966;
	border-radius : 4px;
	padding: 4px;
	font-size: 12px;
	text-align: left;
}

.oneToManyFlowLink_Gjhor {
	background-color: #DDF7F7;
	color: black;
	border: 1px solid #0F9D58;
	border-radius : 4px;
	padding: 4px;
	font-size: 12px;
	text-align: left;
}

.manyToOneFlowLink_Gs47y {
	background-color: #C9DAF8;
	color: black;
	border: 1px solid #1C4587;
	border-radius : 4px;
	padding: 4px;
	font-size: 12px;
	text-align: left;
}

.manyToManyFlowLink_AnmtG {
	background-color: #fcc;
	color: black;
	border: 1px solid #955;
	border-radius : 4px;
	padding: 4px;
	font-size: 12px;
	text-align: left;
}

.deviceFlowNode_QgPlg {
	padding: 4px;
	font-size: 14px;
	border-radius: 4px;
}



.oneToOneGroup_WD7eM {
	background-color: #FFF2CC;
	color: black;
	border: none;
	font-size: 12px;
	text-align: center;
	padding: 4px;
}

.oneToManyGroup_sb5Dm {
	background-color: #DDF7F7;
	color: black;
	border: none;
	font-size: 12px;
	text-align: center;
	padding: 4px;
}

.manyToOneGroup_NMAgB {
	background-color: #C9DAF8;
	color: black;
	border: none;
	font-size: 12px;
	text-align: center;
	padding: 4px;
}

.manyToManyGroup_Hn51K {
	background-color: #fcc;
	color: black;
	border: none;
	font-size: 12px;
	text-align: center;
	padding: 4px;
}

.er.relationshipLabelBox {
	color: black !important;
	fill : #DDF7F7 !important;
	opacity: 1.0 !important;
	fill-opacity: 1.0 !important;
}

.er.relationshipLabel{
	padding : 4px;
}

.er.entityBox{
	fill : #E4E2F7 !important;
	stroke : #261ACB !important;
}

.er.attributeBoxOdd, .er.attributeBoxEven {
	stroke : #261ACB !important;
}


.edgeLabel {
	fill : #E4E2F7 !important;
	stroke : #261ACB !important;
	stroke-width: 1px;
	opacity: 1;
	background : #DDF7F7 !important;
	/* border:1px solid black; */
	border-radius: 4px;
}


.outer.title-state,  .node.default .divider {
	fill : #E4E2F7 !important;
	stroke : #261ACB !important;

}

.nodeLabel {
	font-weight : normal !important;
}

.classTitle .nodeLabel {
	font-weight : bolder !important;
}`, "",{"version":3,"sources":["webpack://./src/screens/blueprint/Graph.css"],"names":[],"mappings":";AACA;CACC,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,cAAc;CACd,sBAAsB;CACtB,SAAS;CACT,YAAY;AACb;;AAEA;CACC,+BAA+B;EAC9B,+BAA+B;CAChC,yBAAyB;EACxB,yBAAyB;CAC1B,iBAAiB;CACjB,YAAY;CACZ,eAAe;CACf,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,yBAAyB;CACzB,mBAAmB;CACnB,YAAY;CACZ,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,yBAAyB;CACzB,mBAAmB;CACnB,YAAY;CACZ,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,yBAAyB;CACzB,mBAAmB;CACnB,YAAY;CACZ,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;CACtB,YAAY;CACZ,sBAAsB;CACtB,mBAAmB;CACnB,YAAY;CACZ,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,kBAAkB;AACnB;;;;AAIA;CACC,yBAAyB;CACzB,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,sBAAsB;CACtB,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,uBAAuB;CACvB,yBAAyB;CACzB,uBAAuB;CACvB,4BAA4B;AAC7B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,yBAAyB;CACzB,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;;AAGA;CACC,yBAAyB;CACzB,2BAA2B;CAC3B,iBAAiB;CACjB,UAAU;CACV,+BAA+B;CAC/B,4BAA4B;CAC5B,kBAAkB;AACnB;;;AAGA;CACC,yBAAyB;CACzB,2BAA2B;;AAE5B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC","sourcesContent":["\n.flowLegend {\n\tposition : absolute;\n\tright : 8px;\n\tbottom : 8px;\n\tdisplay : flex;\n\tflex-direction: column;\n\tgap : 8px;\n\tz-index: 100;\n}\n\n.blueprint {\n\t/* background-color: #cdffb2; */\n  /* border: 1px solid #6eaa49; */\n\tbackground-color: #E4E2F7;\n  border: 1px solid #261ACB;\n\tborder-radius : 0;\n\tcolor: black;\n\tfont-size: 12px;\n\tpadding: 4px;\n\ttext-align: left;\n}\n\n.oneToOneFlowLink {\n\tbackground-color: #FFF2CC;\n\tcolor: black;\n\tborder: 1px solid #FFD966;\n\tborder-radius : 4px;\n\tpadding: 4px;\n\tfont-size: 12px;\n\ttext-align: left;\n}\n\n.oneToManyFlowLink {\n\tbackground-color: #DDF7F7;\n\tcolor: black;\n\tborder: 1px solid #0F9D58;\n\tborder-radius : 4px;\n\tpadding: 4px;\n\tfont-size: 12px;\n\ttext-align: left;\n}\n\n.manyToOneFlowLink {\n\tbackground-color: #C9DAF8;\n\tcolor: black;\n\tborder: 1px solid #1C4587;\n\tborder-radius : 4px;\n\tpadding: 4px;\n\tfont-size: 12px;\n\ttext-align: left;\n}\n\n.manyToManyFlowLink {\n\tbackground-color: #fcc;\n\tcolor: black;\n\tborder: 1px solid #955;\n\tborder-radius : 4px;\n\tpadding: 4px;\n\tfont-size: 12px;\n\ttext-align: left;\n}\n\n.deviceFlowNode {\n\tpadding: 4px;\n\tfont-size: 14px;\n\tborder-radius: 4px;\n}\n\n\n\n.oneToOneGroup {\n\tbackground-color: #FFF2CC;\n\tcolor: black;\n\tborder: none;\n\tfont-size: 12px;\n\ttext-align: center;\n\tpadding: 4px;\n}\n\n.oneToManyGroup {\n\tbackground-color: #DDF7F7;\n\tcolor: black;\n\tborder: none;\n\tfont-size: 12px;\n\ttext-align: center;\n\tpadding: 4px;\n}\n\n.manyToOneGroup {\n\tbackground-color: #C9DAF8;\n\tcolor: black;\n\tborder: none;\n\tfont-size: 12px;\n\ttext-align: center;\n\tpadding: 4px;\n}\n\n.manyToManyGroup {\n\tbackground-color: #fcc;\n\tcolor: black;\n\tborder: none;\n\tfont-size: 12px;\n\ttext-align: center;\n\tpadding: 4px;\n}\n\n:global( .er.relationshipLabelBox ) {\n\tcolor: black !important;\n\tfill : #DDF7F7 !important;\n\topacity: 1.0 !important;\n\tfill-opacity: 1.0 !important;\n}\n\n:global( .er.relationshipLabel ){\n\tpadding : 4px;\n}\n\n:global( .er.entityBox ){\n\tfill : #E4E2F7 !important;\n\tstroke : #261ACB !important;\n}\n\n:global( .er.attributeBoxOdd ), :global( .er.attributeBoxEven ) {\n\tstroke : #261ACB !important;\n}\n\n\n:global( .edgeLabel ) {\n\tfill : #E4E2F7 !important;\n\tstroke : #261ACB !important;\n\tstroke-width: 1px;\n\topacity: 1;\n\tbackground : #DDF7F7 !important;\n\t/* border:1px solid black; */\n\tborder-radius: 4px;\n}\n\n\n:global( .outer.title-state ),  :global( .node.default .divider ) {\n\tfill : #E4E2F7 !important;\n\tstroke : #261ACB !important;\n\n}\n\n:global( .nodeLabel ) {\n\tfont-weight : normal !important;\n}\n\n:global( .classTitle .nodeLabel ) {\n\tfont-weight : bolder !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flowLegend": `flowLegend_J0vA1`,
	"blueprint": `blueprint_eSzYM`,
	"oneToOneFlowLink": `oneToOneFlowLink_dFxLn`,
	"oneToManyFlowLink": `oneToManyFlowLink_Gjhor`,
	"manyToOneFlowLink": `manyToOneFlowLink_Gs47y`,
	"manyToManyFlowLink": `manyToManyFlowLink_AnmtG`,
	"deviceFlowNode": `deviceFlowNode_QgPlg`,
	"oneToOneGroup": `oneToOneGroup_WD7eM`,
	"oneToManyGroup": `oneToManyGroup_sb5Dm`,
	"manyToOneGroup": `manyToOneGroup_NMAgB`,
	"manyToManyGroup": `manyToManyGroup_Hn51K`
};
export default ___CSS_LOADER_EXPORT___;
